// Modules
import { useEffect, useState } from 'react'
import { useTracking } from 'react-tracking'

// Application
import { AnalyticsProps } from 'typings'

export function usePageTracker<T extends number>(InitialSteps: Record<T, AnalyticsProps> | null, step: T) {
    const [trackedSteps, setTrackedStep] = useState<Record<T, AnalyticsProps> | undefined>(InitialSteps || undefined)
    const [actualStep, setActualStep] = useState<Number>()
    const { trackEvent } = useTracking()

    useEffect(() => {
        if (InitialSteps && !trackedSteps) {
            setTrackedStep(InitialSteps)
        }
    }, [InitialSteps, trackedSteps])

    useEffect(() => {
        if (trackedSteps) {
            // eslint-disable-next-line prefer-destructuring
            const track = trackedSteps[step]
            if (actualStep !== step) {
                trackEvent(track)
                setTrackedStep({ ...trackedSteps, [step]: track })
                setActualStep(step)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [step, trackedSteps])
}
